module.exports = __webpack_public_path__ + "media/printed-materials/educators-materials-resources-9d7bbcd7.jpg";